import { nanoid } from 'nanoid';

/**
 * generates a unique formFieldId for a form field
 * @returns
 */
export const generateFormFieldId = () => {
  return nanoid(6);
};
